import { render, staticRenderFns } from "./MainLedgerCreate.vue?vue&type=template&id=49314be6&scoped=true"
import script from "./MainLedgerCreate.vue?vue&type=script&lang=js"
export * from "./MainLedgerCreate.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerCreate.vue?vue&type=style&index=0&id=49314be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49314be6",
  null
  
)

export default component.exports